import { render, staticRenderFns } from "./ReceiptInfo.vue?vue&type=template&id=5d0546d3&scoped=true&"
import script from "./ReceiptInfo.vue?vue&type=script&lang=js&"
export * from "./ReceiptInfo.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptInfo.vue?vue&type=style&index=0&id=5d0546d3&lang=scss&module=true&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5d0546d3",
  null
  
)

export default component.exports